import React, { Children } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

export default function AuditionTalentSkillsGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container spacing={0}>
      <Grid size={8}>{items[0]}</Grid>
      <Grid size={12}>{items[1]}</Grid>
      <Grid size={12}>{items[2]}</Grid>
      <Grid size={12}>{items[3]}</Grid>
      <Grid size={12}>{items[4]}</Grid>
      <Grid size={12}>{items[5]}</Grid>
      <Grid size={12}>{items[6]}</Grid>
    </Grid>
  );
}

AuditionTalentSkillsGrid.propTypes = {
  children: PropTypes.node,
};
